"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrompt = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

function usePrompt(isDirty, modalProps) {
  var blocker = react_1["default"].useCallback(function (tx) {
    antd_1.Modal.confirm(Object.assign(Object.assign({
      title: 'You have unsaved changes.',
      content: 'You will lose them if you continue. Are you sure you want to close this?',
      okText: 'Go Back & Keep Changes',
      cancelButtonProps: {
        danger: true
      },
      cancelText: 'Continue Without Saving',
      width: 650
    }, modalProps), {
      onCancel: function onCancel() {
        tx.retry();
      }
    }));
  }, [modalProps]);
  (0, react_router_dom_1.useBlocker)(blocker, isDirty);
}

exports.usePrompt = usePrompt;